const ClaimUpdatesHero = () => (
  <div className="bg-foreground px-4 py-10 text-white sm:py-14">
    <div className="container mx-auto max-w-6xl">
      <h1 className="mb-3 text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl">
        Car Finance Claim Updates
      </h1>
      <p className="max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
        Keeping you informed about your claim and the latest developments
        affecting car finance compensation.
      </p>
    </div>
  </div>
)

export default ClaimUpdatesHero
